module.exports = __webpack_public_path__ + "images/dodge_small70020535b5ee5789f2dbe44c7f959f33.png";